export default {
      id: "chevron-right-24-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite-46b249.svg#chevron-right-24-usage",
      toString: function () {
        return this.url;
      }
    }